import React from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate } from 'react-router-dom';
import 'swiper/css';
import PageHeader from '../../components/PageHeader';
import { CurrencyItemWithSkeleton } from '../../components/Skeletons/ItemsWithSkeleton';
import AppConfig from '../../config';
import './Assets.scss';

const { routes } = AppConfig;

const Assets = () => {
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const loadingAvailableCurrencies = useSelector(store => store.app.availableCurrenciesLoading);

	const navigate = useNavigate();

	const sortedCurrencies = [...availableCurrencies].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const openAssetPage = currency => {
		navigate({ pathname: routes.asset, search: createSearchParams({ currencyId: currency.Id }).toString() });
	};

	return (
		<div className='Assets'>
			<PageHeader header={'Assets'} />
			<div className='Assets__body'>
				<CurrencyItemWithSkeleton
					loading={loadingAvailableCurrencies}
					items={sortedCurrencies}
					skeletonCount={sortedCurrencies.length}
					onClick={openAssetPage}
				/>
			</div>
		</div>
	);
};

export default Assets;
